import { render, staticRenderFns } from "./StatisticTopSellProductOfMonth.vue?vue&type=template&id=a13a614c"
import script from "./StatisticTopSellProductOfMonth.vue?vue&type=script&lang=js"
export * from "./StatisticTopSellProductOfMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports